(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire13c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire13c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9CtTZ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $700edb9c43b09179$export$6503ec6e8aabbaf; }, function (v) { return $700edb9c43b09179$export$6503ec6e8aabbaf = v; });
var $700edb9c43b09179$export$6503ec6e8aabbaf;
var $700edb9c43b09179$export$f7ad0328861e2f03;
"use strict";
var $700edb9c43b09179$var$mapping = new Map();
function $700edb9c43b09179$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$700edb9c43b09179$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $700edb9c43b09179$var$resolve(id) {
    var resolved = $700edb9c43b09179$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$700edb9c43b09179$export$6503ec6e8aabbaf = $700edb9c43b09179$var$register;
$700edb9c43b09179$export$f7ad0328861e2f03 = $700edb9c43b09179$var$resolve;

});

parcelRegister("jOXN4", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e6e110f3e89fa2a7$export$bdfd709ae4826697; }, function (v) { return $e6e110f3e89fa2a7$export$bdfd709ae4826697 = v; });
var $e6e110f3e89fa2a7$export$bdfd709ae4826697;
var $e6e110f3e89fa2a7$export$c9e73fbda7da57b6;
var $e6e110f3e89fa2a7$export$5a759dc7a1cfb72a;
"use strict";
var $e6e110f3e89fa2a7$var$bundleURL = {};
function $e6e110f3e89fa2a7$var$getBundleURLCached(id) {
    var value = $e6e110f3e89fa2a7$var$bundleURL[id];
    if (!value) {
        value = $e6e110f3e89fa2a7$var$getBundleURL();
        $e6e110f3e89fa2a7$var$bundleURL[id] = value;
    }
    return value;
}
function $e6e110f3e89fa2a7$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e6e110f3e89fa2a7$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e6e110f3e89fa2a7$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e6e110f3e89fa2a7$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e6e110f3e89fa2a7$export$bdfd709ae4826697 = $e6e110f3e89fa2a7$var$getBundleURLCached;
$e6e110f3e89fa2a7$export$c9e73fbda7da57b6 = $e6e110f3e89fa2a7$var$getBaseURL;
$e6e110f3e89fa2a7$export$5a759dc7a1cfb72a = $e6e110f3e89fa2a7$var$getOrigin;

});

var $ae23d49a2b599eab$exports = {};


(parcelRequire("9CtTZ")).register((parcelRequire("jOXN4")).getBundleURL("7fOoB"), JSON.parse('["7fOoB","index.7018e9e1.js","6TEKx","refresh-icon.009bc1af.png","10CGt","screenshot-icon.5e549a92.png","5S9sA","undo-icon.b172f9dc.png","6KUAG","redo-icon.691e2ad6.png","g1NCG","play-icon.1244da64.png","jJIqZ","pause-icon.6262a893.png","2hwfy","step-back-icon.f400c3a2.svg","94WuP","step-forward-icon.599f4f84.svg","50iGV","expand-icon.b0fdaf64.svg","lx1bX","collapse-icon.478bcd7a.svg","k9AzJ","binicon.f413c360.png","f6vVU","prev-arrow-white-icon.843aaffe.png","9DYor","next-arrow-white-icon.78989721.png","9BHgy","help-icon.1cb874a1.png","ksOJO","collapsible-icon.a6e3afbe.png","1de7W","download-icon.2bc7be26.png","45x3n","k_grid_density-formula.9368f611.png","alEXh","atom_properties_shot.51402526.png","bx2Va","BandStructure-icon.59236816.png","jKVfP","GW-Workflow-icon.94691551.png","jxira","MD-Workflow-icon.2ec9a2c9.png","7LqOU","Spectroscopy-icon.c3192620.png","lqAcc","DesignedWorkflow-icon.c0d0b72f.png","8dWV6","SISSOactive-icon.80ed65b9.png","kQ5cd","ControlGenerator-icon.7e7e6fcc.png","6oEN2","OutputAnalyzer-icon.9f19e705.png","ijtEj","SimpleCalculation-icon.f33bfdcc.png","hnU73","StructureBuilder-icon.37caf98b.png"]'));

})();
//# sourceMappingURL=index.runtime.08eafc97.js.map
